import { render, staticRenderFns } from "./SpToasts.vue?vue&type=template&id=0c002160&scoped=true&"
import script from "./SpToasts.vue?vue&type=script&lang=js&"
export * from "./SpToasts.vue?vue&type=script&lang=js&"
import style0 from "./SpToasts.vue?vue&type=style&index=0&id=0c002160&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c002160",
  null
  
)

export default component.exports